/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { MOBILE_FOOTER_GROUP, MOBILE_FOOTER_GROUP_LIST } from './constants';

import { IFarmlandsFooterData, IFooterData } from './farmlands-footer.data';
import { IFarmlandsFooterProps } from './farmlands-footer.props.autogenerated';

export interface IFarmlandsFooterViewProps extends IFarmlandsFooterProps<IFarmlandsFooterData> {
    actionResponse: IFooterData;
    selectedIndex: number;
    activeClass: string;
    elementHeight: number;
    toggleLinkGroup(index: number): void;
}

export interface IFooterState {
    footerData?: any;
    selectedIndex: number;
    activeClass: string;
    elementHeight: number;
}

/**
 *
 * FarmlandsFooter component
 * @extends {React.PureComponent<IFarmlandsFooterProps<IFarmlandsFooterData>>}
 */
class FarmlandsFooter extends React.PureComponent<IFarmlandsFooterProps<IFarmlandsFooterData>, IFooterState> {
    constructor(props: IFarmlandsFooterProps<IFarmlandsFooterData>) {
        super(props);
        this.state = {
            activeClass: '',
            selectedIndex: -1,
            elementHeight: 0
        };
    }

    public componentDidMount(): void {
        // Call the footerAction, then store data in local state
        this.props.data.footerAction.then((data) => {
            this.setState({
                footerData: data.footer
            });
        });
    }

    public render(): JSX.Element | null {
        const { activeClass, selectedIndex, elementHeight } = this.state;

        const toggleLinkGroup = (index: number) => {
            const targetGroup = document.getElementById(`${MOBILE_FOOTER_GROUP}-${index}`);
            const targetGroupList = document.getElementById(`${MOBILE_FOOTER_GROUP_LIST}-${index}`);
            let isActive = true;
            const classList = targetGroup?.classList;
            if (classList?.contains('active')) {
                isActive = false;
            }

            this.setState({
                activeClass: isActive ? 'active' : '',
                selectedIndex: index,
                elementHeight: isActive ? (targetGroupList ? targetGroupList.scrollHeight : 0) : 0
            });
        };

        const viewProps: IFarmlandsFooterViewProps = {
            ...this.props,
            actionResponse: this.state?.footerData,
            toggleLinkGroup,
            selectedIndex,
            activeClass,
            elementHeight
        };
        const isLoading = this.state?.footerData === undefined;

        // Only show footer when we have a response from API and is stored in state
        return isLoading ? null : this.props.renderView(viewProps);
    }
}

export default FarmlandsFooter;
